import React from 'react';

export default function SolidCard({ children }) {
	return (
		<div className="solid-card">
			{children}
		</div>
	);
}